import { isNil } from 'ramda';
import { Nullish } from 'shared/web';
import { EagColumn } from '../types/EagColumn';

/**
 * Safely retrieves the header name from an EagColumn for use in filter placeholders.
 *
 * @param column - The EagColumn object (may be null/undefined in edge cases)
 * @returns The header name or null if unavailable
 */
export const getFilterFieldName = (column: EagColumn | Nullish): string | Nullish => {
  if (isNil(column)) {
    return null;
  }
  return column.headerName ?? null;
};